import alt from "../alt";

let Worker = Worker || require("workerjs");

class ImageActions {
  constructor() {
    this.worker = null;
  }

  arrayBufferToBase64 = buffer => {
    var binary = "";
    var bytes = [].slice.call(new Uint8Array(buffer));
    bytes.forEach(b => (binary += String.fromCharCode(b)));
    return window.btoa(binary);
  };

  init() {
    return dispatch => {
      dispatch();
      if (!this.worker) {
        this.worker = new Worker("/js/imageLoader.worker.js");
      }

      this.worker.onmessage = msg => {
        let index = msg.data.src.split("_")[1].split(".")[0];

        let image64 = "data:image/jpeg;base64," + msg.data.buffer;

        let image = new Image();
        image.src = image64;

        //console.log(image64);

        image.onload = () => {
          this.addFrame(index, image);
        };
      };

      let imageArr = new Array(875).fill("").map((e, i) => {
        return `/images/bgFrames/v2/frame_${i + 1}.jpg`;
      });

      let stopFrames = [202, 317, 358, 427, 541, 824];

      stopFrames.map(frame => {
        frame = frame - 1;
        imageArr.unshift(imageArr.splice(frame, 1)[0]);
      });

      this.worker.postMessage(imageArr);
    };
  }

  addFrame(frame, image) {
    return { frame, image };
  }
}

module.exports = alt.createActions(ImageActions);
